'use client';
/* eslint-disable no-restricted-imports */
import type { LottieComponentProps as InternalLottieComponentProps } from 'lottie-react';
import { useEffect, useState, type ReactElement } from 'react';

type LottieComponent = (
  props: InternalLottieComponentProps
) => React.ReactElement;

export interface LottieComponentProps extends InternalLottieComponentProps {
  fallback?: ReactElement | null;
}

export function Lottie({ fallback = null, ...props }: LottieComponentProps) {
  const [LottieInternal, setLottie] = useState<LottieComponent | null>(null);

  useEffect(() => {
    void import('lottie-react').then((mod) => {
      const _Lottie = mod.default;
      const LottieComponent =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof _Lottie === 'function' ? _Lottie : (_Lottie as any).default;
      setLottie(() => LottieComponent);
    });
  }, []);

  if (!LottieInternal) {
    return fallback;
  }

  return <LottieInternal {...props} />;
}
